import { Flex, Text, Image, createIcon, Heading } from "@chakra-ui/react";
import type { HowItWorksCardProps } from "../../HowItWorks.types";

const Line = createIcon({
  displayName: "Line",
  viewBox: "0 0 2 214",
  defaultProps: {
    width: "2px",
    height: "100",
  },
  path: (
    <>
      <path
        d="M1 0.895264L0.999994 141.508L0.999991 212.895"
        stroke="url(#paint0_linear_1737_15014)"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1737_15014"
          x1="1"
          y1="0.895264"
          x2="1"
          y2="212.895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#87BAFF" />
          <stop offset="1" stopColor="#87BAFF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </>
  ),
});

export const HowItWorks5StepsDetailedCard = ({ icon, title, description, number }: HowItWorksCardProps) => {
  const isLastCard = number === 5;

  return (
    <Flex w="full" align="flex-start" h="full">
      <Flex h="full" direction="column" align="center">
        <Flex
          mt={3}
          borderRadius="full"
          border="1px solid"
          borderColor="primary.400"
          h={8}
          minW={8}
          align="center"
          justify="center"
        >
          <Text fontSize="sm" fontWeight="medium" color="primary.400">
            {number}
          </Text>
        </Flex>
        {!isLastCard && <Line h="100%" />}
      </Flex>
      <Flex direction="column" align="flex-start" ml={4} mb={isLastCard ? 0 : 9}>
        <Image src={icon} w="fit-content" mb={2} />
        <Heading variant="h5" py={4}>
          {title}
        </Heading>
        <Text fontSize="md" color="greyscale.600" pt={0}>
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};
